import React from 'react';
export default function ProgressBar({ value = 0, max = 100 }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="progress"><div className="bar" style={{ width: `${pct}%` }} /></div>
  );
}
